import { IconButton } from '@mui/joy';
import { CaretLeft, CaretRight } from '@phosphor-icons/react';
import { useState, useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import { Document, Page, pdfjs } from 'react-pdf';

pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.js`;

interface PDFViewersProps {
  fileName: string;
}
interface DocumentProps {
  numPages: number;
}

function scaleDocumentWidth(
  number: number,
  screenWidth: number,
  maxNumber: number | null,
) {
  const scaleFactor = screenWidth / 1920;
  if (maxNumber && number * scaleFactor >= maxNumber) return maxNumber;
  return number * scaleFactor;
}

const PDFViewers = ({ fileName }: PDFViewersProps) => {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [numOfPages, setNumOfPages] = useState<number>(0);
  const [pageNumber, setPageNumber] = useState<number>(1);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const onDocumentLoadSuccess = ({ numPages }: DocumentProps) => {
    setNumOfPages(numPages);
    setPageNumber(1);
  };

  const prevPage = () => {
    if (pageNumber > 1) setPageNumber(pageNumber - 1);
  };

  const nextPage = () => {
    if (pageNumber < numOfPages) setPageNumber(pageNumber + 1);
  };
  return (
    <div className='flex flex-col items-center'>
      <div className='flex justify-between items-center w-screen bg-transparent p-5'>
        <IconButton onClick={prevPage}>
          <CaretLeft size={48} />
        </IconButton>
        <div className='w-auto'>
          <Document
            file={fileName}
            onLoadSuccess={onDocumentLoadSuccess}
            error='Something went wrong'
          >
            <Page
              pageNumber={pageNumber}
              renderTextLayer={false}
              renderAnnotationLayer={false}
              devicePixelRatio={2}
              width={scaleDocumentWidth(550, windowWidth, null)}
            />
          </Document>
        </div>
        <IconButton onClick={nextPage}>
          <CaretRight size={48} />
        </IconButton>
      </div>
      <div className='bg-black bg-opacity-50 w-150px self-center rounded px-4 py-2'>
        <p className='text-white text-center'>
          <FormattedMessage defaultMessage='Page' /> {pageNumber} / {numOfPages}
        </p>
      </div>
    </div>
  );
};

export default PDFViewers;
